// Мутации для form-module.
export const SET_LOGIN = 'SET_LOGIN';
export const SET_PASSWORD = 'SET_PASSWORD';

// Мутации для home-module.
export const SET_ACTION_NUMBER = 'SET_ACTION_NUMBER';

// Мутации для insured-event-claim-module.
export const SET_INSURANCE_PRODUCT = 'SET_INSURANCE_PRODUCT';
export const SET_COMPONENT = 'SET_COMPONENT';
export const SET_AGREE = 'SET_AGREE';

// Мутации для shared-data-module.
export const SET_DATE = 'SET_DATE';
export const SET_EVENT = 'SET_EVENT';
export const SET_CAUSE = 'SET_CAUSE';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_COMMENTS = 'SET_COMMENTS';

// Мутации для personal-protection-module.
export const SET_PERSONAL_PROTECTION_COMPONENT = 'SET_PERSONAL_PROTECTION_COMPONENT';

// Мутации для premier-invest-module.
export const SET_PREMIER_INVEST_COMPONENT = 'SET_PREMIER_INVEST_COMPONENT';

// Мутации для premier-life-module.
export const SET_PREMIER_LIFE_COMPONENT = 'SET_PREMIER_LIFE_COMPONENT';

// Мутации для personal-data-form-module.
export const SET_PERSONAL_FORM_TYPE = 'SET_PERSONAL_FORM_TYPE';
export const SET_PERSONAL_LAST_NAME = 'SET_PERSONAL_LAST_NAME';
export const SET_PERSONAL_NAME = 'SET_PERSONAL_NAME';
export const SET_PERSONAL_PATRONYMIC = 'SET_PERSONAL_PATRONYMIC';
export const SET_PERSONAL_EMAIL = 'SET_PERSONAL_EMAIL';
export const SET_PERSONAL_BANK = 'SET_PERSONAL_BANK';
export const SET_PERSONAL_CONTRACT_NUMBER = 'SET_PERSONAL_CONTRACT_NUMBER';
export const SET_PERSONAL_APPEAL = 'SET_PERSONAL_APPEAL';
export const SET_PERSONAL_AGREE = 'SET_PERSONAL_AGREE';

// Мутации для bank-card-protection-module.
export const SET_MONEY_LOSS_IS_CHECKED = 'SET_MONEY_LOSS_IS_CHECKED';
export const SET_MONEY_LOSS_VALUE = 'SET_MONEY_LOSS_VALUE';
export const SET_CARD_REISSUE_IS_CHECKED = 'SET_CARD_REISSUE_IS_CHECKED';
export const SET_CARD_REISSUE_VALUE = 'SET_CARD_REISSUE_VALUE';
export const SET_DOCUMENTS_RESTORATION_IS_CHECKED = 'SET_DOCUMENTS_RESTORATION_IS_CHECKED';
export const SET_DOCUMENTS_RESTORATION_VALUE = 'SET_DOCUMENTS_RESTORATION_VALUE';
export const SET_KEYS_REPLACEMENT_IS_CHECKED = 'SET_KEYS_REPLACEMENT_IS_CHECKED';
export const SET_KEYS_REPLACEMENT_VALUE = 'SET_KEYS_REPLACEMENT_VALUE';
export const SET_PHONE_PURCHASE_IS_CHECKED = 'SET_PHONE_PURCHASE_IS_CHECKED';
export const SET_PHONE_PURCHASE_VALUE = 'SET_PHONE_PURCHASE_VALUE';
export const SET_ACQUISITION_EQUIPMENT_IS_CHECKED = 'SET_ACQUISITION_EQUIPMENT_IS_CHECKED';
export const SET_ACQUISITION_EQUIPMENT_VALUE = 'SET_ACQUISITION_EQUIPMENT_VALUE';
export const SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED = 'SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED';
export const SET_INVOLUNTARY_LOAN_PROCESSING_VALUE = 'SET_INVOLUNTARY_LOAN_PROCESSING_VALUE';

// export const SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED = 'SET_INVOLUNTARY_LOAN_PROCESSING_IS_CHECKED';
// export const SET_INVOLUNTARY_LOAN_PROCESSING_VALUE = 'SET_INVOLUNTARY_LOAN_PROCESSING_VALUE';

 export const SET_FIRST_DISABILITY_GROUP_IS_CHECKED = 'SET_FIRST_DISABILITY_GROUP_IS_CHECKED';
 export const SET_FIRST_DISABILITY_GROUP_VALUE = 'SET_FIRST_DISABILITY_GROUP_VALUE';

 export const SET_SECOND_DISABILITY_GROUP_IS_CHECKED = 'SET_SECOND_DISABILITY_GROUP_IS_CHECKED';
 export const SET_SECOND_DISABILITY_GROUP_VALUE = 'SET_SECOND_DISABILITY_GROUP_VALUE';

 export const SET_TEMPORARY_DISABILITY_IS_CHECKED = 'SET_TEMPORARY_DISABILITY_IS_CHECKED';
 export const SET_TEMPORARY_DISABILITY_VALUE = 'SET_TEMPORARY_DISABILITY_VALUE';

 export const SET_INJURY_IS_CHECKED = 'SET_INJURY_IS_CHECKED';
 export const SET_INJURY_VALUE = 'SET_INJURY_VALUE';

 export const SET_HOSPITALIZATION_IS_CHECKED = 'SET_HOSPITALIZATION_IS_CHECKED';
 export const SET_HOSPITALIZATION_VALUE = 'SET_HOSPITALIZATION_VALUE';

 export const SET_LEAVING_LIFE_IS_CHECKED = 'SET_LEAVING_LIFE_IS_CHECKED';
 export const SET_LEAVING_LIFE_VALUE = 'SET_LEAVING_LIFE_VALUE';

export const SET_OTHER_IS_CHECKED = 'SET_OTHER_IS_CHECKED';
export const SET_OTHER_VALUE = 'SET_OTHER_VALUE';

// Мутации для maximum-protection-module.
export const SET_MAXIMUM_PROTECTION_INSURANCE = 'SET_MAXIMUM_PROTECTION_INSURANCE';
export const SET_MAXIMUM_PROTECTION_COMPONENT = 'SET_MAXIMUM_PROTECTION_COMPONENT';

// Мутации для anticrisis.
export const SET_ANTICRISIS_INSURANCE = 'SET_ANTICRISIS_INSURANCE';
export const SET_ANTICRISIS_COMPONENT = 'SET_ANTICRISIS_COMPONENT';

// Мутации для barrier-module.
export const SET_BARRIER_VALUE = 'SET_BARRIER_VALUE';
export const SET_BARRIER_COMPONENT = 'SET_BARRIER_COMPONENT';

// Мутации для contract-info-insurer-module.
export const SET_INSURER_PERSON_TYPE = 'SET_INSURER_PERSON_TYPE';
export const SET_DATE_OF_BIRTH = 'SET_DATE_OF_BIRTH';

// Мутации для house-module.
export const SET_INTERIOR_DECORATION_AND_EQUIPMENT = 'SET_INTERIOR_DECORATION_AND_EQUIPMENT';
export const SET_HOME_MOVABLE_PROPERTY = 'SET_HOME_MOVABLE_PROPERTY';
export const SET_RESPONSIBILITY = 'SET_RESPONSIBILITY';
export const SET_STRUCTURAL_ELEMENTS = 'SET_STRUCTURAL_ELEMENTS';
export const SET_INTERIOR_DECORATION = 'SET_INTERIOR_DECORATION';
export const SET_INSURED_OR_OWNER = 'SET_INSURED_OR_OWNER';
export const SET_THIRD_PERSON = 'SET_THIRD_PERSON';

// Мутации для persons-shared-module.
export const SET_ANOTHER_LAST_NAME = 'SET_ANOTHER_LAST_NAME';
export const SET_ANOTHER_NAME = 'SET_ANOTHER_NAME';
export const SET_ANOTHER_PATRONYMIC = 'SET_ANOTHER_PATRONYMIC';
export const SET_TELEPHONE = 'SET_TELEPHONE';
export const SET_EMAIL = 'SET_EMAIL';

// Мутации для contract-info-shared-module.
export const SET_CONTRACT_NUMBER = 'SET_CONTRACT_NUMBER';
export const SET_CONTRACT_DATE = 'SET_CONTRACT_DATE';
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const SET_NAME = 'SET_NAME';
export const SET_PATRONYMIC = 'SET_PATRONYMIC';

// Мутации для contract-info-applicant-module
export const SET_APPLICANT_PERSON_TYPE = 'SET_APPLICANT_PERSON_TYPE';

// Мутации для premier-insurance-module.
export const SET_PREMIER_INSURANCE_COMPONENT = 'SET_PREMIER_INSURANCE_COMPONENT';